import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-103">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-purple-900/10 via-zinc-950 to-zinc-950 pointer-events-none" data-id="element-104" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-105">
        <FadeIn data-id="element-106">
          <div className="inline-flex items-center justify-center p-3 bg-zinc-900 rounded-full mb-6 border border-zinc-800" data-id="element-107">
            <Sparkles className="w-6 h-6 text-purple-400" data-id="element-108" />
          </div>
          <h2 className="text-3xl sm:text-5xl font-bold mb-8 leading-tight" data-id="element-109">
            El Método de Sacudida Somática (MSS)
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-110">
          <p className="text-xl sm:text-2xl text-zinc-300 leading-relaxed font-serif italic max-w-3xl mx-auto" data-id="element-111">
            A diferencia de la meditación tradicional, el MSS utiliza
            micro-intervenciones físicas diseñadas para "sacudir" la energía
            estancada en cada chakra.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-112">
          <p className="mt-8 text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-113">
            Es un interruptor biológico que obliga a tu sistema nervioso a pasar
            del miedo a la acción en 7 días exactos.
          </p>
        </FadeIn>
      </div>
    </section>;
}